module.exports = __webpack_public_path__ + "img/mx.2728f57a.svg";